import React, { useState } from 'react';
import AddOnServices from '../../../components/Dashboard/AddOnServices';
import './style.scss';

const AddOnServicesPage = () =>{

    return(
        <div className='addon_services_page_wrapper'>
            <AddOnServices/>
        </div>
    )
}

export default AddOnServicesPage;